import { render, staticRenderFns } from "./Outdent.vue?vue&type=template&id=dac5c272&"
import script from "./Outdent.vue?vue&type=script&lang=js&"
export * from "./Outdent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports